module.exports = __webpack_public_path__ + "img/logo.862653b6.png";